// @ts-strict-ignore
import _ from 'lodash';
import { BaseToolStoreService } from '@/hybrid/toolSelection/baseToolStore.service';
import { TREND_TOOLS } from '@/hybrid/toolSelection/investigate.module';

export type ManualConditionStore = ReturnType<typeof sqManualConditionStore>['exports'];

export function sqManualConditionStore(sqBaseToolStore: BaseToolStoreService) {
  const store = {
    initialize() {
      this.state = this.immutable(sqBaseToolStore.COMMON_PROPS);
    },

    exports: {},

    /**
     * Exports state so it can be used to re-create the state later using `rehydrate`.
     *
     * @return {Object} State for the store
     */
    dehydrate() {
      return this.state.serialize();
    },

    /**
     * Sets the references panel state
     *
     * @param {Object} dehydratedState - Previous state usually obtained from `dehydrate` method.
     */
    rehydrate(dehydratedState) {
      this.state.merge(dehydratedState);
    },

    handlers: {},

    /**
     * Removes properties from config which are stored as part of the formula.
     *
     * @param {Object} config - The state that will be saved to UIConfig
     * @return {Object} The modified config
     */
    modifyConfigParams(config) {
      return _.omit(config, ['maximumDuration', 'advancedParametersCollapsed']);
    },
  };

  return sqBaseToolStore.extend(store, TREND_TOOLS.MANUAL_CONDITION);
}
